/**
 * Excel sınıf sütunundan 1..12 arası sınıf düzeyi çıkarır.
 * "9", "09", "9. Sınıf", "9.Sınıf" gibi değerleri kabul eder.
 */
export function parseGradeLevel(raw) {
    if (raw == null)
        return null;
    if (typeof raw === 'number' && Number.isInteger(raw)) {
        return raw >= 1 && raw <= 12 ? raw : null;
    }
    const trimmed = String(raw).trim();
    if (!trimmed)
        return null;
    const match = trimmed.match(/^0*(\d{1,2})/);
    if (!match)
        return null;
    const grade = Number(match[1]);
    return grade >= 1 && grade <= 12 ? grade : null;
}
//# sourceMappingURL=parse-grade.js.map